/*
 * @Descripttion:
 * @Author: Jun Chen
 * @Date: 2021-1-22 23:07:49
 */
export default [
  {
    path: '/seal',
    name: 'seal',
    hidden: false,
    meta: {
      title: '印章管理',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/sealIndex',
        name: 'sealIndex',
        hidden: false,
        meta: {
          title: '印章管理',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/seal-manage/manage'], resolve)
      },
      {
        path: '/sealDetail',
        name: 'sealDetail',
        hidden: true,
        meta: {
          title: '查看详情',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/seal-manage/detail'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-seal-manage.js